import { Component, OnInit } from '@angular/core';
import {
  ApplicationState,
  getProducts,
  getPublicWifiCreateAliasSuccess,
  getPublicWifiProductsJwt,
} from '../../store/reducers';
import * as ProductsActions from '../../store/actions/products.actions';
import * as PublicWifiActions from '../store/actions/public-wifi.actions';
import { Store } from '@ngrx/store';
import { OnDestroyHookDirective } from '../../shared/hooks';
import {
  getMprdProductType,
  PlcCodes,
  Product,
} from '@dch/products-business-logic';
import { combineLatest } from 'rxjs';
import { CustomerService } from '@proximus/ng-common';
import { CustomerAccount } from '@proximus/common-business-logic';

@Component({
  selector: 'mprd-public-wifi-selector',
  templateUrl: './public-wifi-selector.component.html',
  styleUrls: ['./public-wifi-selector.component.css'],
})
export class PublicWifiSelectorComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  jwt: string;
  products: Array<Product>;
  selectedProduct: Product;
  private dataLoaded: boolean;

  constructor(
    private store: Store<ApplicationState>,
    private customerService: CustomerService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      combineLatest([
        this.store.select(getProducts),
        this.store.select(getPublicWifiProductsJwt),
      ]).subscribe((res: [Array<Product>, string]) => {
        const products = res[0];
        this.jwt = res[1];
        if (products && products.length > 0 && this.jwt && !this.dataLoaded) {
          this.dataLoaded = true;
          this.products = products.filter(
            (product) => product.isFonEligible && product.plc === PlcCodes.FI,
          );
          if (this.products.length > 0) {
            this.selectedProduct = this.products[0];
            this.loadAccounts();
          }
        }
      }),
    );
    this.store.dispatch(new ProductsActions.GetProducts());
    this.store.dispatch(new PublicWifiActions.GetPublicWifiProducts());

    // refresh account list after new alias creation
    this.addSubscription(
      this.store.select(getPublicWifiCreateAliasSuccess).subscribe((res) => {
        if (res && res.value) {
          this.loadAccounts();
        }
      }),
    );
  }

  onProductChange(accessNumber: string) {
    this.selectedProduct = this.products.find(
      (product) => product.accessNumber === accessNumber,
    );
    this.loadAccounts();
  }

  loadAccounts() {
    this.addSubscription(
      this.customerService
        .getCustomerAccount()
        .subscribe((customerAccount: CustomerAccount) => {
          let serviceId;
          const productType = getMprdProductType(this.selectedProduct);
          let ownedMsisdn = true;
          if ('internet' === productType) {
            serviceId = this.selectedProduct.soccabisId;
          } else if ('mobile' === productType) {
            serviceId = this.selectedProduct.accessNumber;
            ownedMsisdn =
              customerAccount.getOwnedMsisdns() &&
              customerAccount.getOwnedMsisdns().length > 0 &&
              customerAccount
                .getOwnedMsisdns()
                .findIndex((value) => value.msisdn === serviceId) !== -1;
          }
          this.store.dispatch(
            new PublicWifiActions.GetPublicWifiAccounts({
              serviceId,
              jwt: this.jwt,
              ownedMsisdn,
            }),
          );
        }),
    );
  }
}
